'use strict';
angular.module('schoolLinqApp').directive('taxParametersDataEntry', taxParameterDataEntryController);

function taxParameterDataEntryController() {
	var controller = [
		'$scope',
		'$q',
		'employeeTaxService',
		'BUSY_MESSAGE',
		function (scope, $q, employeeTaxService, BUSY_MESSAGE) {
			scope.loadTaxParameters = function () {
				scope.fields = [];
				scope.groups = [];
				scope.dirty = false;
				scope.errors = [];

				scope.busyMessage = BUSY_MESSAGE.Loading;
				scope.busyPromise = employeeTaxService.getCurrentIRSW4(scope.employeeId).then(finishedGettingTaxParameters);

				function finishedGettingTaxParameters(response) {
					if (response.data.isValid) {
						scope.fields = response.data.results;
						scope.fieldsBackup = angular.copy(scope.fields);
						scope.groups = scope.getGroups();
					} else {
						scope.errors.push(response.data.error);
					}

					if (scope.mustReload === true) {
						scope.mustReload = false;
						scope.afterSave();
					}
				}
			};

			scope.getGroups = function () {
				let groupNames = _.uniq(
					_.map(scope.fields, function (field) {
						return field.TaxDescription;
					})
				);

				let groups = [];
				_.forEach(groupNames, function (groupName) {
					let groupFields = scope.getGroupFields(groupName);
					groups.push({
						groupName: groupName,
						groupFields: groupFields,
						updatingName: false,
					});
				});

				return groups;
				//return _.sortBy(groups, function (group) { return group.groupName.toLowerCase(); });
			};

			scope.getGroupFields = function (groupName) {
				let groupFields = _.filter(scope.fields, function (field) {
					return field.TaxDescription === groupName;
				});
				//var groupFields = _.sortBy(_.filter(scope.fields, function (field) {
				//    return field.ParameterDescription === groupName;
				//}), 'Priority');
				return groupFields;
			};

			scope.validateInput = function (field) {
				if (field.ParameterValue.match(field.Regex)) {
					field.ErrorMsg = null;
				} else {
					field.ErrorMsg = '*Invalid';
				}
			};

			scope.isDirty = function () {
				scope.dirty = _.some(scope.fields, function (field) {
					return field.isDirty;
				});
				return scope.dirty;
			};

			scope.isValid = function () {
				scope.errors = [];

				scope.fields
					.filter(function (field) {
						return !field.IsOptional && (field.ParameterValue || '') == '';
					})
					.forEach(function (field) {
						scope.errors.push(field.ParameterDescription + ' is required.');
					});

				scope.fields
					.filter(function (field) {
						return (field.IsOptional || (field.ParameterValue || '') != '') && field.ErrorMsg;
					})
					.forEach(function (field) {
						scope.errors.push(field.ParameterDescription + ' is invalid.');
					});

				return scope.errors.length == 0;
			};

			scope.save = function () {
				if (!scope.isValid()) {
					return;
				}

				scope.busyMessage = BUSY_MESSAGE.Saving;
				scope.busyPromise = employeeTaxService.post(scope.fields).then(_.partial(finishedSavingContact));

				function finishedSavingContact(response) {
					if (response.data.isValid) {
						scope.fieldsBackup = angular.copy(scope.fields);
						scope.groups = scope.getGroups();
						scope.afterSave();
						employeeTaxService.dirty = true;
						employeeTaxService.editing = false;
						scope.loadTaxParameters();
					} else {
						if (_.isArray(response.data.errors)) scope.errors = response.data.errors;
						else scope.errors = [response.data.errors];
					}
				}
			};

			scope.cancelChanges = function () {
				scope.fields = angular.copy(scope.fieldsBackup);
				scope.groups = scope.getGroups();
				scope.errors = [];
				employeeTaxService.editing = false;
				scope.afterCancel();
			};
			scope.isEdit = function () {
				return employeeTaxService.editing;
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			employeeId: '=', // integer Id of the employee
			busyPromise: '=', // reference to calling page
			busyMessage: '=', // reference to calling page
			okToLoad: '=', // flag to enable/disable loading of data
			readonly: '=', // flag indicating read-only status
			dirty: '=', // let's consumer know if the directive has unsaved changes
			doCancel: '=', // allows consumer to trigger the directive's cancelChanges() function
			afterSave: '&', // reference to function to run after successful save operation
			afterCancel: '&', // reference to function to run after cancel operation
		},
		//replace: true,
		template: require('@ajs/templates/taxParametersDataEntry.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.$watch('okToLoad', function (value) {
				if (value === true && scope.employeeId) scope.loadTaxParameters();
			});

			scope.$watch('doCancel', function (value) {
				if (value === true) {
					scope.doCancel = false;
					scope.cancelChanges();
				}
			});
		},
	};
}
